import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';

class BnTab extends LitElement {
  static get properties() {
    return {
      active: { type: Boolean, reflect: true },
      disabled: { type: Boolean, reflect: true },
      href: { type: String },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
        margin: 0 3px;
      }
      .tab {
        color: var(--blue-50);
        text-decoration: none;
        line-height: 2em;
        padding: 6px 9px 3px 9px;
        display: inline-block;
        cursor: pointer;
        border: 0 solid transparent;
        border-bottom-width: 3px;
        font-weight: 600;
      }
      :hover:not(disabled) {
        background-color: var(--blue-10);
      }
      :host([disabled]) .tab {
        color: var(--gray-70) !important;
        border-color: transparent !important;
        cursor: default;
      }
      :host([active]) .tab {
        border-color: var(--blue-50);
      }
    `];
  }

  render() {
    if (this.href) {
      return html`<a class="tab" href="${this.href}"><slot></slot></a>`;
    } else {
      return html`<a class="tab"><slot></slot></a>`;
    }
  }
}

window.customElements.define('bn-tab', BnTab);
